// extracted by mini-css-extract-plugin
export default {"body":"BurnModal_body__V1Y70","burnButton":"BurnModal_burnButton__ZFXya"};